/**
 * Umami custom-event tracking. The script is loaded in pages/_app.tsx and
 * attaches `window.umami` once it runs; calls made before that (or when the
 * script is blocked) are silently no-ops.
 *
 * For plain link/button clicks prefer the declarative `data-umami-event="…"`
 * attribute; use this helper when the event fires from imperative JS.
 */
type UmamiEventData = Record<string, string | number | boolean | undefined>;

/* eslint-disable no-unused-vars -- type-only declaration, params/name aren't runtime vars */
declare global {
  interface Window {
    umami?: { track(eventName: string, eventData?: UmamiEventData): void };
  }
}
/* eslint-enable no-unused-vars */

export const trackEvent = (
  eventName: string,
  eventData?: UmamiEventData
): void => {
  if (typeof window === "undefined") return;
  window.umami?.track(eventName, eventData);
};
